import { digObject } from '@domain-group/javascript-utils'

import { DashboardModule, Form, Text } from '@domain-group/suit-theme'

import useCurrentUser from '@hooks/useCurrentUser'
import { useUserForm } from '@hooks/useUser'

import { isAdmin } from '@functions/user'

import type { RoleModel } from '@models/types'
import ScopedConditionalContent from '@components/ScopedConditionalContent'

interface AccountProps {
  role: RoleModel,
  userForm: ReturnType <typeof useUserForm>,
}

const Account = (props: AccountProps) => {
  const { role, userForm } = props

  const {
    entityState: {
      options: {
        training_mode,
      },
      password,
      password_confirmation,
      template_master,
      username,
    },
    handlers,
  } = userForm

  const userIsAdmin = isAdmin(role.title)

  const { isMasterAdmin, permissions } = useCurrentUser()
  const hasAdvancedPermissions = digObject(permissions, 'admin.users.advanced')

  return (
    <DashboardModule title="Account">
      <Form padding="large">
        <Form.Row>
          <Form.Field label="Role">
            <input disabled value={role.title} />
          </Form.Field>

          {/*
           // @ts-expect-error TS2322 */}
          <Form.Field label="* Username" marginTop={['large', 0]}>
            <input name="username" type="text" value={username} {...handlers} />
          </Form.Field>
        </Form.Row>

        {((hasAdvancedPermissions && userIsAdmin) || isMasterAdmin) && (
          <Form.Row marginTop="large">
            {hasAdvancedPermissions && userIsAdmin && (
              <Form.Field label="Template Master">
                {/*
                 // @ts-expect-error TS2322 */}
                <select
                  data-value-type="boolean"
                  name="template_master"
                  value={template_master}
                  {...handlers}
                >
                  <option value="true">Yes</option>
                  <option value="false">No</option>
                </select>
              </Form.Field>
            )}

            {isMasterAdmin && (
              // @ts-expect-error TS2322
              <Form.Field label="Training Mode" marginTop={['large', 0]}>
                {/*
                 // @ts-expect-error TS2322 */}
                <select
                  data-value-type="boolean"
                  name="options.training_mode"
                  value={training_mode}
                  {...handlers}
                >
                  <option value="false">No</option>
                  <option value="true">Yes</option>
                </select>
              </Form.Field>
            )}
          </Form.Row>
        )}

        <Form.Row marginTop="large">
          <Form.Field label="* Password">
            <input name="password" type="password" value={password} {...handlers} />
          </Form.Field>

          {/*
           // @ts-expect-error TS2322 */}
          <Form.Field label="* Confirm Password" marginTop={['large', 0]}>
            <input name="password_confirmation" type="password" value={password_confirmation} {...handlers} />
          </Form.Field>
        </Form.Row>

        {userIsAdmin && (
          <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="large">
            Passwords must be at least 8 characters in length and contain: an upper case letter,
            a lower case letter, a number, and a special character.
          </Text>
        )}
      </Form>
    </DashboardModule>
  )
}

export default Account
